/*
 * Copyright (c) 2024 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import {H3} from "@blueprintjs/core"

import env from "../../core/context/Env"

export default function EulaAcceptanceRequired() {
    return (
        <div>
            <div
                className="content"
                style={{
                    textAlign: "center",
                    marginTop: "40px",
                }}
            >
                <H3 className="biocrates-commons-heading">
                    EULA acceptance required
                </H3>
                <p style={{marginBottom: "40px"}}>
                    Please accept the EULA. Go to the Subscriptions tab in my
                    biocrates and accept the EULA.
                    <br />
                    If you don't have administrator access, please ask your
                    organization admin to accept the EULA in your organization's
                    account.
                </p>
                <a
                    href={env("INVALID_LICENSE_URL")}
                    className="biocrates-commons-anchor-normal"
                >
                    Visit my biocrates
                </a>
            </div>
        </div>
    )
}
